import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { setCookie } from 'app/common/utils/cookie.util';
import { ISignInResponse } from 'app/services/auth/auth.interface';
import { AuthService } from 'app/services/auth/auth.service';
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { MagicService } from 'app/services/wallet/magic/magic.service';
import { WalletconnectService } from 'app/services/wallet/walletconnect/walletconnect.service';
import { eStatus } from 'app/services/web3/web3.config';
import { first } from 'rxjs';
import { paremetersForRedirectUrl } from '../../../services/marketing/marketing-parameters';
import { MarketingGuestService } from 'app/services/marketing/marketing-guest.service';
import { eNetworkName } from 'app/services/contract/contract.config';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {

  helpLink: string = 'https://discord.com/invite/hYRjSfsWXt';
  signInFormGroup: FormGroup;
  isForgotPsw: boolean = false;
  recoveryPassFormGroup: FormGroup;
  isPasswordVisible: boolean = false;
  queryParam: { [key: string]: string };
  marketingSettings: any = paremetersForRedirectUrl['default'];



  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private magicService: MagicService,
    private walletconnectService: WalletconnectService,
    private toastService: ToastService,
    private router: ActivatedRoute,
    private marketingGuestService: MarketingGuestService

  ) {
    this.signInFormGroup = this.fb.group({
      username: this.fb.control('', [Validators.required/* , UserValidator.userloginValidator(), Validators.minLength(4), Validators.maxLength(20) */]),
      password: this.fb.control('', [Validators.required, /* PasswordValidator.passwordloginValidator() */])
    });

    this.recoveryPassFormGroup = this.fb.group({
      email: this.fb.control('', [Validators.required, Validators.email]),
    });

  }

  ngOnInit(): void {
    //to cache query param and send to signUp page
    this.router.queryParams.subscribe(res => this.queryParam = res);
    //get data for marketing
    this.marketingGuestService.marketingGuestDRedirectUrlata$.subscribe(data => {
      this.marketingSettings = data;
    });

  }

  login(): void {
    this.authService.signIn(this.signInFormGroup.value).pipe(first())
      .subscribe(response => {
        if (response.status == "done") {
          let missingWallet: boolean = !response.walletAddress ? true : false;
          if (response.walletProvider === "magic") this.loginWithMagic(response, missingWallet);
          else this.loginWithWalletconnect(response, missingWallet);
        } else {
          console.log('errorLogin', response);
          this.toastService.genericError();
        }

      });
  }

  loginWithWalletconnect(response: ISignInResponse, missingWallet: boolean) {

    this.walletconnectService.login(missingWallet
    );
    this.walletconnectService.loggedStatus.subscribe(status => {
      if (status.status === eStatus.success) {
        {
          let walletconnectSelectedWallet = status.value.selectedAddress ? status.value.selectedAddress : status.value.accounts[0];
          if (response.walletAddress.toLowerCase() === walletconnectSelectedWallet.toLowerCase()) {
            setCookie('login', 'wallet', 0.5);
            setCookie('loginEmail', response.email, 0.5);
            setCookie('recordedWallet', response.walletAddress, 0.5);
            this.authService.routeAfterSuccessfulLogin(response);
          } else {
            console.log('wallet provided different');
            this.toastService.genericError('errorMsg.walletAlreadyUsed');
          }
        }
      }
    })
  }

  loginWithMagic(response: ISignInResponse, missingWallet: boolean) {
    // let network: string = localStorage.getItem('magicNetwork');

    // let _network: eNetworkName = (<any>eNetworkName)[network];
    // network = network ? network : environment.allowedNetwork[0];
    this.magicService.login(
      response.email,
      missingWallet
    );
    this.magicService.loggedSuccessfully.subscribe(isLogged => {
      if (isLogged) {
        setCookie('login', 'magic', 0.5);
        setCookie('loginEmail', response.email, 0.5);
        setCookie('recordedWallet', response.walletAddress, 0.5);
        this.authService.routeAfterSuccessfulLogin(response);
      }
    })
  }

  forgotPassword() {
    this.authService.forgotPassword(this.recoveryPassFormGroup.get('email').value).subscribe(
      (response: any) => {
        if (response.status == 'done') {
          this.toastService.add({
            severity: "info",
            summary: 'shared.sent',
            detail: 'toastMessage.passwordSent',
          });
        }
        else this.toastService.genericError();
      }
    )

  }

}